import React, { FC } from 'react';

import { Flex } from '@chakra-ui/react';

import { Routes } from 'react-router-dom';

import ROUTES, { routesSettings } from 'constants/routes';

import SitePortal from './SitePortal';
import SiteOrder from 'routes/cms/SiteOrder';
import NotFound from 'routes/portal/NotFound';

import getRoute from 'components/core/RouteWithSubRoutes';

const routeConfig = Object.freeze({
  [ROUTES.CMS_SITE_PORTAL]: {
    element: <SitePortal />,
    path: routesSettings.CMS_SITE_PORTAL.path,
  },
  [ROUTES.CMS_SITE_ORDER]: {
    element: <SiteOrder />,
    path: routesSettings.CMS_SITE_ORDER.path,
  },
  [ROUTES.PORTAL_NOT_FOUND]: {
    element: <NotFound />,
    path: routesSettings.PORTAL_NOT_FOUND.path,
  },
});
console.log(routeConfig, 'routeConfig');

const CmsRoutes: FC = () => {
  return (
    <Flex flex={1}>
      <Flex bg="#fff" flexGrow={1} flexBasis={0} overflow="auto">
        <Routes>
          {Object.entries(routeConfig).map(([key, val]) => getRoute(val))}
        </Routes>
      </Flex>
    </Flex>
  );
};

export default CmsRoutes;
